import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Button, Icon, Text } from "@ui-component-library";
import MediaSelector from "../editor/fields/MediaSelector";
import DroneVideo from "../commons/DroneVideo";

const HeroSection = (props) => {
  const handleButtonClick = (href) => {
    window.location.href = href;
  };

  return (
    <TailwindWrapper>
      <section className="w-full py-5 container">
        <div className="flex flex-col-reverse items-center gap-4 lg:gap-16 lg:flex-row py-3 lg:py-24">
          {/* Left Side: Text Content */}
          <div className="w-full flex flex-col gap-8 justify-between">
            <Text tw variant="overlineLargeRegular" className="text-[#737373]">
              {props.sectionName}
            </Text>
            <Text tw variant="text-3xl/leading-normal/medium">
              {props.title}
            </Text>
            <Text
              tw
              className="text-[#737373]"
              variant="text-base/leading-normal/normal"
            >
              {props.text}
            </Text>
            <div className="flex gap-2">
              {props.primaryButtonText && (
                <Button
                  tw
                  variant="primary"
                  onClick={() => handleButtonClick(props.primaryButtonLink)}
                >
                  {props.primaryButtonText}
                </Button>
              )}
              {props.secondaryButtonText && (
                <Button
                  tw
                  variant="tertiary"
                  onClick={() => handleButtonClick(props.secondaryButtonLink)}
                >
                  {props.secondaryButtonText}
                  <Icon tw name="ArrowRightSimple" size="medium" />
                </Button>
              )}
            </div>
          </div>
          <div className="w-full flex justify-center items-center">
            {props.mediaType === "videoUrl" && (
              <div className="h-full aspect-square bg-gray-100 rounded-xl border border-gray-200 overflow-hidden">
                {props.videoUrl && (
                  <div className={"flex-grow-1 overflow-hidden h-full"}>
                    <video
                      autoPlay
                      muted
                      loop
                      playsInline
                      preload="auto"
                      className={`rounded-4 img-fluid w-full h-full object-cover`}
                    >
                      <source
                        src={`${Window.static_path}video/${props.videoUrl}`}
                        type="video/mp4"
                      />
                    </video>
                  </div>
                )}
                {!props.videoUrl && <p>Please add url to uploaded video</p>}
              </div>
            )}
            {props.mediaType === "droneVideo" && (
              <div className="w-full aspect-square bg-gray-100 rounded-xl border border-gray-200 relative overflow-hidden">
                <div className="absolute inset-0 w-full h-full">
                  <DroneVideo
                    fileName={"copture_video_1080p.mp4"}
                    fileNameSmall={"copture_video_360.mp4"}
                    height={""}
                    maxWidth={""}
                    align={""}
                  />
                </div>
              </div>
            )}
            {props.mediaType === "image" && (
              <div className="w-full aspect-square bg-gray-100 rounded-xl border border-gray-200 relative overflow-hidden">
                <img
                  alt={props.alt || "Hero image"}
                  src={props.src || "https://placehold.co/1200x1200"}
                  className={"w-full h-full object-cover vb-rounded"}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </TailwindWrapper>
  );
};

HeroSection.defaultProps = {
  mediaType: "image",
  src: "https://placehold.co/1200x1200",
  alt: "scenic image",
  title: "Headline that solves user's main problem",
  sectionName: "Hero section",
  text: "Follow with one or two sentences that expand on your value proposition. Focus on key benefits and address why users should take action now. Keep it scannable, direct and benefit-driven.",
  primaryButtonText: "Get started",
  primaryButtonLink: "/",
  secondaryButtonText: "Learn more",
  secondaryButtonLink: undefined,
};

HeroSection.resolveFields = (data) => {
  const fields = {
    title: {
      type: "text",
      label: "Title",
    },
    sectionName: {
      type: "text",
      label: "Section Name",
    },
    text: {
      type: "textarea",
      label: "Description Text",
    },
    primaryButtonText: {
      type: "text",
      label: "Primary Button Text",
    },
    primaryButtonLink: {
      type: "text",
      label: "Primary Button Link",
    },
    secondaryButtonText: {
      type: "text",
      label: "Secondary Button Text",
    },
    secondaryButtonLink: {
      type: "text",
      label: "Secondary Button Link",
    },
    mediaType: {
      type: "select",
      label: "Media Type",
      options: [
        { label: "Image", value: "image" },
        { label: "Drone Video", value: "droneVideo" },
        { label: "Video URL", value: "videoUrl" },
      ],
    },
  };

  // Conditional field that's show depending on the media type field above
  if (data.props.mediaType === "image") {
    return {
      ...fields,
      src: {
        type: "custom",
        label: "Image Source",
        render: ({ name, onChange, value }) => (
          <MediaSelector
            name={name}
            label="Image Source"
            type={"img"}
            onChange={onChange}
            value={value}
          />
        ),
      },
      alt: {
        type: "text",
        label: "Image Alt Text",
      },
    };
  }

  // Conditional field that's show depending on the media type field above
  if (data.props.mediaType === "videoUrl") {
    return {
      ...fields,
      videoUrl: {
        type: "text",
        label: "Video URL",
      },
    };
  }

  return fields;
};

export default HeroSection;
